/**
 * Copyright 2025 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { useGetCloudAccountsFilterValuesQuery } from "~/generated/graphql";

export const useGetCloudAccountsFilterValues = () => {
  const { data, loading, error } = useGetCloudAccountsFilterValuesQuery({
    variables: { limit: 1000 },
  });

  return { data, loading, error } as const;
};
